import React from "react";

const Loader = () => {
  return (
    <div class="loader-wrapper">
      <div class="loader">
        <div class="loader4"></div>
      </div>
    </div>
  );
};

export default Loader;
